import { cn } from "../../../../../utils/helpers";
import CaseloadAndCalendarWrapper from "../CaseloadAndCalendarWrapper/CaseloadAndCalendarWrapper";
import ProvidersPendingTasks from "../ProvidersPendingTasks/ProvidersPendingTasks";
import UpcomingAppointments from "../UpcomingAppointments/UpcomingAppointments";

export default function Overview() {
    return (
        <div>
            <div
                className={cn(
                    "flex flex-col gap-y-24 min-[1250px]:flex-row gap-x-24 min-[1250px]:*:basis-1/2 relative"
                )}
            >
                <UpcomingAppointments />
                <ProvidersPendingTasks />
            </div>
            <div className="mt-24">
                <CaseloadAndCalendarWrapper />
            </div>
        </div>
    );
}
